var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49315 2.91705C3.07932 2.71308 3.5 2.15567 3.5 1.5C3.5 0.671573 2.82843 0 2 0C1.17157 0 0.5 0.671573 0.5 1.5C0.5 2.15567 0.920678 2.71308 1.50685 2.91705C1.50234 2.94403 1.5 2.97174 1.5 3V15.5C1.5 15.7761 1.72386 16 2 16C2.27614 16 2.5 15.7761 2.5 15.5V3C2.5 2.97174 2.49766 2.94403 2.49315 2.91705ZM3.5 3.31507C3.5 3.12254 3.61006 2.94759 3.78698 2.87166C4.41594 2.60175 5.96251 2 7.25 2C8.86051 2 10.8764 2.94157 10.9946 2.99741C10.9984 2.99922 11.0014 3.00061 11.0052 3.00232C11.125 3.0554 13.2769 4 14.75 4C15.7269 4 17.0023 3.58457 17.7857 3.28923C18.1248 3.16139 18.5 3.40918 18.5 3.77157V10.673C18.5 10.8716 18.3826 11.0512 18.1983 11.1251C17.5293 11.3934 15.8906 12 14.75 12C13.334 12 11.1504 11.0651 11.0074 11.0032C11.0022 11.001 10.9979 10.999 10.9928 10.9966C10.8582 10.9331 8.85324 10 7.25 10C6.20406 10 4.98712 10.3971 4.2301 10.6909C3.88712 10.824 3.5 10.5744 3.5 10.2065V3.31507Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.eaf3c3d1b7af66e08efe2f70ede51823.svg";
export { ForwardRef as ReactComponent };